import ROUTES from "./routes";
import type { AxiosPromise } from "axios";
import type { AuthValidateTokenResponse } from "./types";
import { apiClient } from "@/api/modules/base";

/**
 * @namespace auth
 */
/**
 *
 * Validate token
 *
 * @method
 * @memberOf auth
 */
export const validateToken = (): AxiosPromise<AuthValidateTokenResponse> => apiClient(ROUTES.AUTH.VALIDATE);
